import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.48693 16.1099L16.4028 5.82177L13.6593 2.91089L5.65433 10.4555L2.91083 7.5446L-5.12004e-05 10.2881L5.48693 16.1099Z",
		fill: "#6b6b6b"
	})
});
export default SvgTick;
